module.exports = __webpack_public_path__ + "static/media/stopwatch.ec94c8ac.png";